import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WorkscheduleComponent } from './workschedule.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [WorkscheduleComponent],
  exports: [
    WorkscheduleComponent
  ],
  providers: [
  ]
})
export class WorkscheduleModule { }
